import React, { PropTypes } from 'react';

import Scroll from 'react-scroll';

class Scroller extends React.Component {

  constructor(props) {
    super(props);
  }

  render () {
    const Link = Scroll.Link;
    /* headerHeight is associated with the HTML property $header-height in
    _variables.scss */
    const headerHeight = -80;

    return (
      <Link
        to={ this.props.to }
        smooth={ true }
        duration={ 400 }
        offset={ headerHeight }
        className="arrow arrow-centered center-block"
      />
    )
  }
}


export default Scroller;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/Scroller.jsx
 **/